define([], function () {
        "use strict";

        function CloseCookie($scope,_i18n, _iamUtils) {
           var  i18n = _i18n;
           var iamUtils = _iamUtils;
            $scope.i18n = i18n;
            $scope.model = {
                chromeUrl:require("custom/images/chrome.png"),
                firefoxUrl:require("custom/images/firefox.png"),
                ieUrl:require("custom/images/ie.png")
            };
        }
        return CloseCookie;
    }
);



// WEBPACK FOOTER //
// ./public/base/js/closecookie/controllers/closecookieController.js